let websdk = {}
if (process.client) {
  websdk = require('easemob-websdk').default
  const rtc = {
    // 用来放置本地客户端。
    client: null,
    // 用来放置本地音视频频轨道对象。
    localAudioTrack: null,
    localVideoTrack: null
  }
  // 初始化IM SDK
  // eslint-disable-next-line no-var, import/no-mutable-exports
  var WebIM = window.WebIM || {}
  WebIM = window.WebIM = websdk
  console.log(process.client, '环境变量=======》')
  WebIM.conn = new WebIM.connection({
    appKey: '1126200310098622#wikifx-im',
    isMultiLoginSessions: true,
    https: true,
    isAutoLogin: true,
    heartBeatWait: '',
    autoReconnectNumMax: 5,
    autoReconnectInterval: 2,
    isStropheLog: false,
    delivery: true,
    isHttpDNS: true
  })
  WebIM.rtc = rtc
}
export default WebIM
